import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Optional, Input, Output, ViewChild, HostListener, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';

class SignatureIntl {
    changes = new Subject();
    pleaseTurnDeviceToLandscapeMode;
    constructor() {
        this.pleaseTurnDeviceToLandscapeMode = "Bitte das Gerät im Querformat halten";
    }
    static ɵfac = function SignatureIntl_Factory(t) { return new (t || SignatureIntl)(); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SignatureIntl, factory: SignatureIntl.ɵfac });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SignatureIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

const _c0$1 = ["sigPad"];
const _c1 = function (a0) { return { "border-canvas": a0 }; };
const WIDTH_TO_HEIGHT_SCALE = 2; // 2 Breit, 1 Hoch
/** ACHTUNG: Der erp-seitigen Reportgenerator kann NICHT mit PNGs umgehen!*/
class SignatureComponent {
    signatureIntl;
    changeDetector;
    /** 'png' oder 'jpg'. ACHTUNG: Der erp-seitige Reportgenerator kann NICHT mit PNGs umgehen! Android kann nicht fehlerfrei mit JP*E*G umgehen (Stand 01.2023)*/
    set fileExtension(p_fileExtension) {
        if (p_fileExtension) {
            if (p_fileExtension == this.JPG || p_fileExtension == this.PNG) {
                this.m_fileExtension = p_fileExtension;
                this.m_fileName = `${this.displayName}.${this.m_fileExtension === this.PNG ? this.PNG : this.JPG}`;
            }
            else {
                throw new Error('Unknown fileExtension');
            }
        }
    }
    ;
    /**Name der Signature OHNE Datei-Endung */
    displayName = 'signature';
    signed = new EventEmitter();
    _canvas;
    set canvas(p) {
        this._canvas = p;
        if (this._canvas) {
            this.m_sigPadElement = this._canvas.nativeElement;
            this.m_sigPadElement.addEventListener('mouseup', this.onDrawingEnd.bind(this));
            this.m_sigPadElement.addEventListener('pointerdown', this.onPointerDown.bind(this));
            this.m_sigPadElement.addEventListener('pointermove', this.onPointerMove.bind(this));
            this.m_sigPadElement.addEventListener('touchend', this.onDrawingEnd.bind(this));
            this.m_context = this.m_sigPadElement.getContext('2d');
            this.adjustCanvasDimensions();
            if (this.m_fileExtension === this.JPG) {
                this.initJpgCanvas();
            }
        }
    }
    ;
    m_signatureIntl;
    /** Bekannter Android Fehler: JP*E*G-Files werden manchmal vom Betriebssystem corrupted
     * public readonly JPEG = 'jpeg'; */
    JPG = 'jpg';
    PNG = 'png';
    B64 = 'base64';
    IMAGE = 'image';
    m_sigPadElement;
    m_context;
    m_isDrawing = false;
    m_signature;
    m_image = new Image();
    m_isMobile = false;
    m_startCoords;
    m_hasDrawn = false;
    /** jpg oder png. Standard ist png. */
    m_fileExtension = 'png';
    /** Zusammengesetzt: displayName.fileExtension */
    m_fileName;
    constructor(signatureIntl, changeDetector) {
        this.signatureIntl = signatureIntl;
        this.changeDetector = changeDetector;
        this.m_fileName = `${this.displayName}.${this.m_fileExtension}`;
        if (this.signatureIntl) {
            this.m_signatureIntl = this.signatureIntl;
        }
        else {
            this.m_signatureIntl = new SignatureIntl();
        }
    }
    ngOnInit() {
        this.m_isMobile = /Android|iPhone|iPad|iPod||webOS|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(navigator.userAgent);
    }
    /**
     * wird benötigt, um die neuen Proportionen des Canvas Element zu ermitteln
     * @param event
     */
    onOrientationChange(event) {
        this.m_isDrawing = false;
        this.adjustCanvasDimensions();
    }
    /**
     * wird benötigt, um die neuen Proportionen des Canvas Element zu ermitteln */
    onResize(event) {
        this.m_isDrawing = false;
        this.adjustCanvasDimensions();
    }
    /**
     * leert das Canvas Element, und setzt die aktuelle Unterschrift zurück
     */
    clear() {
        this.m_context.clearRect(0, 0, this.m_sigPadElement.width, this.m_sigPadElement.height);
        this.m_context.beginPath();
        if (this.m_fileExtension == this.JPG) {
            this.initJpgCanvas();
        }
        this.m_signature = null;
        this.m_image.src = '';
        this.m_hasDrawn = false;
    }
    get isLandscape() {
        return !this.m_isMobile || this.m_isMobile && window.innerWidth > window.innerHeight ? true : false;
    }
    /**
     * Weist dem Canvas Element im richtigen Verhältnis (6/3) Breite und Höhe zu
     * Versucht dabei die größtmögliche Fläche zu verwenden
     */
    adjustCanvasDimensions() {
        const parentWidth = this.m_sigPadElement.parentElement.clientWidth;
        const parentHeight = this.m_sigPadElement.parentElement.clientHeight;
        //höhe und breite des Canvas Elements im Verhältnis 6/3 vorbelegen.
        //Höhe = Elternhöhe 
        // Breite = 2 * Höhe
        let height = parentHeight, width = height * WIDTH_TO_HEIGHT_SCALE;
        // wenn das Seitenverhältnis nicht ins Elternelement passt, 
        //soll stattdessen die gesamte Breite und die Höhe im Verhältnis verwendet werden (6/3)
        if (width > parentWidth) {
            this.m_sigPadElement.width = parentWidth;
            this.m_sigPadElement.height = (this.m_sigPadElement.width / WIDTH_TO_HEIGHT_SCALE);
        }
        else {
            this.m_sigPadElement.height = height;
            this.m_sigPadElement.width = width;
        }
        this.m_sigPadElement.style.width = `${this.m_sigPadElement.width}px`;
        this.m_sigPadElement.style.height = `${this.m_sigPadElement.height}px`;
        this.changeDetector.detectChanges();
        if (this.m_image) {
            if (this.m_fileExtension == this.JPG) {
                this.initJpgCanvas();
            }
            this.m_image.onload = () => {
                setTimeout(e => this.draw(), 500);
            };
            this.m_image.src = this.m_image.src;
        }
    }
    /**
     * zeichnet das aktuelle Bild zurück in das Canvas Element
     */
    draw() {
        this.m_context.drawImage(this.m_image, 0, 0, this.m_sigPadElement.width, this.m_sigPadElement.height);
    }
    onDrawingEnd() {
        this.m_isDrawing = false;
        let signatureUrl = this.m_sigPadElement.toDataURL('image/png');
        this.m_image.src = `data:image/png;${this.B64},${signatureUrl.split(this.B64 + ',')[1]}`;
        if (!this.m_hasDrawn) {
            // Gucken, ob in einem 20x20 Pixel großen Quadrat, um die PointerDown-Coordinate etwas gezeichnet wurde
            // Wird so gemacht, da ein kurzes Tippen unter Andorid dazu führt, dass alle Events (pointerdown, pointermove, touchend)
            // ausgeführt werden und sich die Koordinaten im onPointerDown und onPointerMove unterscheiden. Ansonsten könnte man dort
            // die Werte vergleichen und das m_hasDrawn entsprechend setzen...
            const imgData = this.m_context.getImageData(this.m_startCoords.x - 5, this.m_startCoords.y - 5, 10, 10);
            const pixelBuffer = new Uint32Array(imgData.data.buffer);
            this.m_hasDrawn = pixelBuffer.some(pix => pix !== 0);
        }
        this.signed.emit(this.getSignature());
    }
    onPointerDown(p_event) {
        this.m_isDrawing = true;
        const coords = this.relativeCoords(p_event);
        this.m_startCoords = coords;
        this.m_context.moveTo(coords.x, coords.y);
    }
    onPointerMove(p_event) {
        if (this.m_isDrawing) {
            const coords = this.relativeCoords(p_event);
            this.m_context.lineTo(coords.x, coords.y);
            this.m_context.stroke();
        }
    }
    relativeCoords(event) {
        const bounds = event.target.getBoundingClientRect();
        const x = event.clientX - bounds.left;
        const y = event.clientY - bounds.top;
        return { x: x, y: y };
    }
    getCroppedSignature() {
        var canvas = this.m_context.canvas, w = canvas.width, h = canvas.height, pix = { x: [], y: [] }, imageData = this.m_context.getImageData(0, 0, canvas.width, canvas.height), x, y, index;
        for (y = 0; y < h; y++) {
            for (x = 0; x < w; x++) {
                // Jedes Pixel wird durch vier Array Einträge repräsentiert (RGB + alpha für Transparenz)
                index = (y * w + x) * 4;
                if (this.m_fileExtension == this.JPG) {
                    // Rot-Wert des nächsten Pixels ist nicht voll gesetzt...=> Schwarz bei Schwarz-Weiß-Bild
                    if (imageData.data[index + 4] < 255) {
                        pix.x.push(x);
                        pix.y.push(y);
                    }
                }
                else {
                    // Transparenz-Wert steht auf nicht voll Transparent
                    if (imageData.data[index + 3] > 0) {
                        pix.x.push(x);
                        pix.y.push(y);
                    }
                }
            }
        }
        pix.x.sort((a, b) => a - b);
        pix.y.sort((a, b) => a - b);
        var n = pix.x.length - 1;
        w = 1 + pix.x[n] - pix.x[0];
        h = 1 + pix.y[n] - pix.y[0];
        var cut = this.m_context.getImageData(pix.x[0], pix.y[0], w, h);
        // Canvas für zugeschnittene Unterschrift generieren (vermeidet kurzes Springen der Unterschrift in der Oberfläche)
        var canvas = document.createElement('canvas');
        canvas.width = cut.width;
        canvas.height = cut.height;
        let cropCtx = canvas.getContext('2d');
        if (this.m_fileExtension == this.JPG) {
            cropCtx.fillStyle = "rgb(255,255,255)";
        }
        cropCtx.putImageData(cut, 0, 0);
        let dataUrl = cropCtx.canvas.toDataURL(this.mimeType);
        return this.m_signature = {
            displayName: this.m_fileName,
            type: 'b',
            mimeType: this.mimeType,
            fileExtension: this.m_fileExtension,
            data: dataUrl.split(this.B64 + ',')[1],
        };
    }
    /**
     * liefert das bisher gezeichnete Bild als Tlob aus
     */
    getSignature() {
        let signatureUrl = this.m_sigPadElement.toDataURL(this.mimeType);
        this.m_signature = {
            displayName: this.m_fileName,
            type: 'b',
            mimeType: this.mimeType,
            fileExtension: this.m_fileExtension,
            data: signatureUrl.split(this.B64 + ',')[1],
        };
        return this.m_signature;
    }
    /**
    * Füllt die Canvas mit einem weißen Rectangle aus,
    * auf dem gemalt wird, da JPGs nicht mit transparentem Hintergrund umgehen können.
    * Achtung: Das Zuschneiden der Unterschrift funktioniert so nicht.
    */
    initJpgCanvas() {
        this.m_context.fillStyle = "rgb(255,255,255)";
        this.m_context.fillRect(0, 0, this.m_sigPadElement.width, this.m_sigPadElement.height);
    }
    /** image/[fileExtension(png||jpeg)] */
    get mimeType() {
        // Als Mimetype ist JPEG für JPGs korrekt
        return `${this.IMAGE}/${this.m_fileExtension == this.PNG ? this.m_fileExtension : 'jpeg'}`;
    }
    onTest() {
        this.m_image.src = this.getCroppedSignature().data;
    }
    hasContent() {
        return this.isLandscape && this.m_hasDrawn;
    }
    /**
     * Liefert das Rechteck des Canvas in dem die Unterschrift steht. Wird einer oder beide Parameter angegeben,
     * wird dieses auf ein Rechteck der gleichen Relation von Breite zu Höhe erweitert mit mindestens der angegebenen Breite und Höhe.
     * Wird nur einer der beiden Parameter angegeben wird der zweite aus der Breiten-Höhen-Relation des Canvas bestimmt.
     * Die Erweiterung der Unterschrift erfolgt, indem diese auf ein neues (virtuelles) Canvas der passenden Breite und Höhe
     * in die linke untere Ecke gesetzt wird. Somit bleibt die Proportion der Unterschrift erhalten.
     * @param p_minWidth minimale Breite des Bildes
     * @param p_minHeight minimale Höhe des Bildes
     * @returns
     */
    getCroppedSignatureWithMinDimension(p_minWidth, p_minHeight) {
        let signedCanvas = this.m_context.canvas, width = signedCanvas.width, height = signedCanvas.height;
        let imageData = this.m_context.getImageData(0, 0, width, height);
        let minX = width, maxX = 0, minY = height, maxY = 0;
        let isAnyPixelSet = false;
        for (let y = 0; y < height; y++) {
            for (let x = 0; x < width; x++) {
                // Jedes Pixel wird durch vier Array Einträge repräsentiert (RGB + alpha für Transparenz)
                let index = (y * width + x) * 4;
                let pixelIsSet = false;
                if (this.m_fileExtension == this.JPG)
                    // Rot-Wert des nächsten Pixels ist nicht voll gesetzt...=> Schwarz bei Schwarz-Weiß-Bild
                    pixelIsSet = imageData.data[index + 4] < 255;
                else
                    // Transparenz-Wert steht auf nicht voll Transparent
                    pixelIsSet = imageData.data[index + 3] > 0;
                if (pixelIsSet) {
                    isAnyPixelSet = true;
                    if (x < minX)
                        minX = x;
                    if (x > maxX)
                        maxX = x;
                    if (y < minY)
                        minY = y;
                    if (y > maxY)
                        maxY = y;
                }
            }
        }
        let newData = null;
        if (isAnyPixelSet) {
            if (minX > 0)
                minX--;
            if (minY > 0)
                minY--;
            let imgWidth = maxX - minX + 1, imgHeight = maxY - minY + 1;
            let baseImgCtx = this.drawImageToVirtualContext({ sourceCanvas: this.m_context.canvas, sourceWidth: imgWidth, sourceHeight: imgHeight, sourceX: minX, sourceY: minY });
            let dataUrl;
            // Breite und Höhe müssen jeweils einen vernünftigen Wert haben
            if (p_minWidth || p_minHeight) {
                const minWidth = p_minWidth ?? p_minHeight * WIDTH_TO_HEIGHT_SCALE;
                const minHeight = p_minHeight ?? p_minWidth / WIDTH_TO_HEIGHT_SCALE;
                const targetRatio = minWidth / minHeight;
                const imgRatio = imgWidth / imgHeight;
                let newWidth = imgWidth, newHeight = imgHeight;
                if (imgWidth < minWidth && imgHeight < minHeight) {
                    newWidth = minWidth;
                    newHeight = minHeight;
                }
                else if (imgRatio > targetRatio)
                    newHeight = newWidth / targetRatio;
                else if (imgRatio < targetRatio)
                    newWidth = newHeight * targetRatio;
                const fitCtx = this.drawImageToVirtualContext({ sourceCanvas: baseImgCtx.canvas, targetWidth: newWidth, targetHeight: newHeight, copyImgWithDimensions: true });
                dataUrl = fitCtx.canvas.toDataURL(this.mimeType);
            }
            else {
                dataUrl = baseImgCtx.canvas.toDataURL(this.mimeType);
            }
            newData = dataUrl.split(this.B64 + ',')[1];
        }
        return this.m_signature = {
            displayName: this.m_fileName,
            type: 'b',
            mimeType: this.mimeType,
            fileExtension: this.m_fileExtension,
            data: newData,
        };
    }
    /**
     * Malt auf einem neu erstelltem (virtuellen) Canvas den Inhalt des geg. Canvas im gewünschten Bereich.
     * Werden nur die targetWidth und targetHeight mit der Option copyImgWithDimensions = true angegeben,
     * wird das komplette Canvas auf das neue Canvas mit den gewünschten Dimensionen kopiert.
     * Sofern ein scale < 0,75 angegeben wird, wird das Bild in mehreren Schritten skaliert, um ein besseres Ergebnis zu erzielen.
     * Bei einer Hochskalierung sollte analog vorgegangen werden (ist bislang nicht implementiert!).
     * @param p_imgData
     * @returns
     */
    drawImageToVirtualContext(p_imgData) {
        const sourceX = p_imgData.sourceX ?? 0;
        const sourceY = p_imgData.sourceY ?? 0;
        const sourceWidth = p_imgData.sourceWidth ?? p_imgData.sourceCanvas.width;
        const sourceHeight = p_imgData.sourceHeight ?? p_imgData.sourceCanvas.height;
        const scale = p_imgData.scale ?? 1;
        const targetWidth = p_imgData.targetWidth ?? sourceWidth * scale;
        const targetHeight = p_imgData.targetHeight ?? sourceHeight * scale;
        const targetX = 0;
        // Das Bild soll am unteren Rand ausgerichtet sein
        const targetY = targetHeight - sourceHeight;
        const scaleCap = 0.75;
        if (scale < scaleCap) {
            // Wenn die Sklaierung zu stark ist, wird in mehreren Schritten runterskaliert, damit das Ergebnis besser aussieht
            let scaleSteps = [];
            let currentScale = scale;
            while (currentScale < scaleCap) {
                scaleSteps.push(scale);
                currentScale += scale;
            }
            let lastScaleWidth = Math.ceil(sourceWidth * currentScale);
            let lastScaleHeight = Math.ceil(sourceHeight * currentScale);
            let scaleCtx = this.createCtxAndDrawImage(p_imgData.sourceCanvas, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, lastScaleWidth, lastScaleHeight);
            while (scaleSteps.length > 0) {
                currentScale = scaleSteps.pop();
                let currentScaleWidth = Math.ceil(sourceWidth * currentScale), currentScaleHeight = Math.ceil(sourceHeight * currentScale);
                scaleCtx = this.createCtxAndDrawImage(scaleCtx.canvas, 0, 0, lastScaleWidth, lastScaleHeight, 0, 0, currentScaleWidth, currentScaleHeight);
                lastScaleWidth = currentScaleWidth;
                lastScaleHeight = currentScaleHeight;
            }
            return this.createCtxAndDrawImage(scaleCtx.canvas, 0, 0, lastScaleWidth, lastScaleHeight, 0, 0, lastScaleWidth, lastScaleHeight);
        }
        else
            return this.createCtxAndDrawImage(p_imgData.sourceCanvas, sourceX, sourceY, sourceWidth, sourceHeight, targetX, targetY, targetWidth, targetHeight, p_imgData.copyImgWithDimensions);
    }
    /**
     * Kreiert ein neues (virtuelles) Canvas und malt das gegegeben Canvas mit den Parametern analog zu drawImage hinein.
     */
    createCtxAndDrawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight, copyImgWithDimensions) {
        let tempCanvas = document.createElement('canvas');
        tempCanvas.width = dWidth;
        tempCanvas.height = dHeight;
        let ctx = tempCanvas.getContext('2d');
        if (this.m_fileExtension == this.JPG) {
            ctx.fillStyle = "rgb(255,255,255)";
        }
        if (copyImgWithDimensions) // Dimension des Bildes bleiben erhalten
            ctx.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, sWidth, sHeight);
        else
            ctx.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
        return ctx;
    }
    static ɵfac = function SignatureComponent_Factory(t) { return new (t || SignatureComponent)(i0.ɵɵdirectiveInject(SignatureIntl, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
    static ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SignatureComponent, selectors: [["ui-signature"]], viewQuery: function SignatureComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$1, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.canvas = _t.first);
        } }, hostBindings: function SignatureComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("orientationchange", function SignatureComponent_orientationchange_HostBindingHandler($event) { return ctx.onOrientationChange($event); }, false, i0.ɵɵresolveWindow)("resize", function SignatureComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, i0.ɵɵresolveWindow);
        } }, inputs: { fileExtension: "fileExtension", displayName: "displayName" }, outputs: { signed: "signed" }, decls: 6, vars: 6, consts: [[1, "canvasWrapper"], ["canvasWrapper", ""], [3, "hidden", "ngClass"], ["sigPad", ""], [3, "hidden"]], template: function SignatureComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0, 1);
            i0.ɵɵelement(2, "canvas", 2, 3);
            i0.ɵɵelementStart(4, "p", 4);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("hidden", !ctx.isLandscape)("ngClass", i0.ɵɵpureFunction1(4, _c1, ctx.m_fileExtension == ctx.JPG));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("hidden", ctx.isLandscape);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", ctx.m_signatureIntl.pleaseTurnDeviceToLandscapeMode, "");
        } }, dependencies: [i2.NgClass], styles: ["@charset \"UTF-8\";[_nghost-%COMP%], .canvasWrapper[_ngcontent-%COMP%]{object-fit:cover;overflow:hidden;display:flex;flex:1 1 auto!important}[_nghost-%COMP%]{width:100%}.canvasWrapper[_ngcontent-%COMP%]{justify-content:center}.canvasWrapper[_ngcontent-%COMP%]   canvas[_ngcontent-%COMP%]{touch-action:none;aspect-ratio:6/3;background:rgba(44,62,80,.04);border-bottom:2px solid rgba(0,0,0,.42);border-radius:5px}.border-canvas[_ngcontent-%COMP%]{border:1px solid black;border-radius:5px}"] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SignatureComponent, [{
        type: Component,
        args: [{ selector: 'ui-signature', template: "<div #canvasWrapper class=\"canvasWrapper\">\n    <canvas #sigPad [hidden]=\"!isLandscape\"\n    [ngClass]=\"{'border-canvas': m_fileExtension==JPG}\"></canvas>\n    <p [hidden]=\"isLandscape\"> {{m_signatureIntl.pleaseTurnDeviceToLandscapeMode}}</p>\n</div>", styles: ["@charset \"UTF-8\";:host,.canvasWrapper{object-fit:cover;overflow:hidden;display:flex;flex:1 1 auto!important}:host{width:100%}.canvasWrapper{justify-content:center}.canvasWrapper canvas{touch-action:none;aspect-ratio:6/3;background:rgba(44,62,80,.04);border-bottom:2px solid rgba(0,0,0,.42);border-radius:5px}.border-canvas{border:1px solid black;border-radius:5px}\n"] }]
    }], function () { return [{ type: SignatureIntl, decorators: [{
                type: Optional
            }] }, { type: i0.ChangeDetectorRef }]; }, { fileExtension: [{
            type: Input
        }], displayName: [{
            type: Input
        }], signed: [{
            type: Output
        }], canvas: [{
            type: ViewChild,
            args: ['sigPad', { static: false }]
        }], onOrientationChange: [{
            type: HostListener,
            args: ['window:orientationchange', ['$event']]
        }], onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();

class PlaceholderIntl {
    changes = new Subject();
    noResults;
    constructor() {
        this.noResults = "Keine Ergebnisse";
    }
    static ɵfac = function PlaceholderIntl_Factory(t) { return new (t || PlaceholderIntl)(); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PlaceholderIntl, factory: PlaceholderIntl.ɵfac });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlaceholderIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

const _c0 = function (a0) { return { "mt-0": a0 }; };
function PlaceholderComponent_mat_card_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-card", 2)(1, "mat-card-header")(2, "mat-card-title");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "mat-card-content", 3);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0, !ctx_r0.topMargin));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.m_innerText, " ");
} }
function PlaceholderComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.m_innerText, " ");
} }
class PlaceholderComponent {
    placeholderIntl;
    title;
    embedded = false;
    topMargin = true;
    set innerText(p_innerText) {
        this.m_innerText = p_innerText;
    }
    ;
    m_placeholderIntl;
    m_innerText;
    constructor(placeholderIntl) {
        this.placeholderIntl = placeholderIntl;
        if (this.placeholderIntl) {
            this.m_placeholderIntl = this.placeholderIntl;
        }
        else {
            this.m_placeholderIntl = new PlaceholderIntl();
        }
        if (!this.innerText) {
            this.m_innerText = this.m_placeholderIntl.noResults;
        }
    }
    ngOnInit() {
    }
    static ɵfac = function PlaceholderComponent_Factory(t) { return new (t || PlaceholderComponent)(i0.ɵɵdirectiveInject(PlaceholderIntl, 8)); };
    static ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlaceholderComponent, selectors: [["ui-placeholder"]], inputs: { title: "title", embedded: "embedded", topMargin: "topMargin", innerText: "innerText" }, decls: 3, vars: 2, consts: [["class", "mb-1", 3, "ngClass", 4, "ngIf", "ngIfElse"], ["div", ""], [1, "mb-1", 3, "ngClass"], [1, "text-center"]], template: function PlaceholderComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, PlaceholderComponent_mat_card_0_Template, 6, 5, "mat-card", 0);
            i0.ɵɵtemplate(1, PlaceholderComponent_ng_template_1_Template, 2, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const _r1 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.embedded)("ngIfElse", _r1);
        } }, dependencies: [i2.NgClass, i2.NgIf, i3.MatCard, i3.MatCardContent, i3.MatCardHeader, i3.MatCardTitle] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlaceholderComponent, [{
        type: Component,
        args: [{ selector: 'ui-placeholder', template: "<mat-card *ngIf=\"embedded; else div\" class=\"mb-1\" [ngClass]=\"{'mt-0': !topMargin}\">\n    <mat-card-header>\n      <mat-card-title>{{title}}</mat-card-title>\n    </mat-card-header>\n    <mat-card-content class=\"text-center\">\n      {{m_innerText}}\n    </mat-card-content>\n  </mat-card>\n  \n  <ng-template #div>     \n    <div>\n        {{m_innerText}}\n    </div>\n  </ng-template>\n" }]
    }], function () { return [{ type: PlaceholderIntl, decorators: [{
                type: Optional
            }] }]; }, { title: [{
            type: Input
        }], embedded: [{
            type: Input
        }], topMargin: [{
            type: Input
        }], innerText: [{
            type: Input,
            args: ['innerText']
        }] }); })();

class UiLibModule {
    static ɵfac = function UiLibModule_Factory(t) { return new (t || UiLibModule)(); };
    static ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: UiLibModule });
    static ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            MatCardModule] });
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UiLibModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SignatureComponent,
                    PlaceholderComponent
                ],
                imports: [
                    CommonModule,
                    MatCardModule
                ],
                exports: [
                    SignatureComponent,
                    PlaceholderComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(UiLibModule, { declarations: [SignatureComponent,
        PlaceholderComponent], imports: [CommonModule,
        MatCardModule], exports: [SignatureComponent,
        PlaceholderComponent] }); })();

/*
 * Public API Surface of ui
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PlaceholderComponent, SignatureComponent, SignatureIntl, UiLibModule };
